import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/[id]/page.tsx");
